class SeafarerLanguage {
    id = null;
    seafarer_id = null;
    language_id = null;
    level = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default SeafarerLanguage;
